// extracted by mini-css-extract-plugin
export var buttonSkeleton = "GooglePayPrimaryView-module--buttonSkeleton--5eb6b";
export var fields = "GooglePayPrimaryView-module--fields--b5656";
export var googlePayButtonContainer = "GooglePayPrimaryView-module--googlePayButtonContainer--af176";